import React, { useState, useEffect } from 'react';
import firebase from '../util/firebase';

export default function DataList() {
    const [dataList, setDataList] = useState();

        useEffect(()=> {
            const todoRef = firebase.database().ref("contacts");
            todoRef.on("value",(snapshot)=>{
            const data = snapshot.val();
                const dataList = [];
                for (let id in data) {
                    dataList.push(data[id]);
                }
                console.log(dataList);
                setDataList(dataList);
                document.getElementById("myDiv").innerHTML = `Aktuelle Anzahl der Unterzeichner*innen: ${dataList.length}`
            })
        }, []);

return (
    <div> 
        
        {dataList ? dataList.map((data)=> <div>{data.firstName} {data.lastName} ({data.age}) - {data.destination}</div>) : ''}
        
    </div>
)
}